// extracted by mini-css-extract-plugin
export default {"tag":"useGroupTagRender_tag__gaf4z"};